import styles from "@/pages/admin/UserManagementPage/dropdownPill.module.css";

// Dropdown's filter input/icon are raw <input>/<svg> elements (not wrapped in
// InputText the way MultiSelect's are), so their pt shape is flat —
// { className } directly, not nested under `.root` like HierarchyBreadcrumb's
// MultiSelect pt objects need.
export const dropdownPillPt = {
  emptyMessage: { className: styles.emptyMessage },
  filterContainer: { className: styles.filterContainer },
  filterIcon: { className: styles.filterIcon },
  filterInput: { className: styles.filterInput },
  header: { className: styles.header },
  input: { className: styles.pillLabel },
  item: { className: styles.item },
  list: { className: styles.list },
  panel: { className: styles.panel },
  root: { className: styles.pill },
  trigger: { className: styles.pillTrigger },
  wrapper: { className: styles.wrapper },
};
